const id = 'awsconnect';

/**
 * Speichert Key in Session-Objekt
 *
 * @param key
 * @param value
 */
const save = (key, value) => {
  const keyProcessed = processKey(key);

  // Session-Objekt holen
  let storageObject = JSON.parse(sessionStorage.getItem(id));

  if (storageObject === null || storageObject === {}) {
    storageObject = {
      [keyProcessed]: value
    };
  } else {
    // Key in Session-Objekt suchen und ersetzen
    for (let i = 0; i < storageObject.length; i++) {
      if (storageObject[i] === 'key') {
        storageObject[i] = value;
        break;
      }
    }

    storageObject[keyProcessed] = value;
  }

  sessionStorage.setItem(id, JSON.stringify(storageObject));
};

/**
 * Speichert Key/Value-Paar gemeinsam mit anderen zusammengehörigen Werten
 *
 * @param parentKey
 * @param key
 * @param value
 * @param overwrite
 */
const saveParentKey = (parentKey, key, value, overwrite = false) => {
  // Altes Objekt aus Session holen
  const currentObject = get(parentKey);

  // Key in altem Objekt gegebenenfalls zurücksetzen
  if (overwrite) {
    currentObject[key] = null;
  }

  // Neues Objekt erzeuen
  const newObject = {
    [key]: value
  };

  // Altes und neues Objekt zusammenführen und speichern
  const mergedObject = {...currentObject, ...newObject};
  save(parentKey, mergedObject);
};

/**
 * Speichert Key in Session-Objekt und behandelt den JSON-Value als Array
 *
 * @param $element
 */
const saveArrayItem = ($element) => {
  const key = processKey($element.name);
  let value = $element.value;
  let filter = get('filter');
  let aValueFromStorage = filter[key];

  if ($element.checked) {
    // Leeres Array erzeugen, falls noch keines besteht
    if (!aValueFromStorage) {
      aValueFromStorage = [];
    }

    // Wenn Checkbox aktiv ist, wird der Wert zum Array hinzugefügt
    if (Array.isArray(aValueFromStorage)) {
      aValueFromStorage.push(value);
    }

    saveParentKey('filter', key, aValueFromStorage);
  } else {
    // Wenn Checkbox nicht aktiv ist, wird der Wert aus dem Array gelöscht
    filter[key] = aValueFromStorage.filter((elem) => {
      return elem !== value;
    });

    save('filter', filter);
  }
};

/**
 * Entfernt ungewünschte Zeichen aus dem Key
 *
 * @param key
 * @returns {*}
 */
const processKey = (key) => {
  if (key) {
    return key.replace(/\[]/g, '');
  }
  return key;
};

/**
 * Holt einen Key aus dem Session-Objekt
 *
 * @param key
 * @returns {{}}
 */
const get = (key) => {
  const storageObject = JSON.parse(sessionStorage.getItem(id));
  let value = null;

  if (storageObject !== null && storageObject !== {}) {
    Object.keys(storageObject).forEach(function (objectKey) {
      if (objectKey === key) {
        value = storageObject[objectKey];
      }
    });
  }

  return value;
};

/**
 * Prüft, ob es sich bei einem String um die Repräsentation eines JSON-Objekts handelt
 *
 * @param str
 * @returns {boolean}
 */
const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export {
  get,
  isJson,
  processKey,
  save,
  saveArrayItem,
  saveParentKey
};
